import React, { useEffect, useState } from 'react';

import './home.scss'

import Button from 'react-bootstrap/Button';

import doorboxblob from '../../assets/img/doorboxblob.png'
import doorboxblob2 from '../../assets/img/doorboxblob2.png'
import Swipercomponent from '../../components/Swiper/Swipercomponent';

import Accordion from 'react-bootstrap/Accordion';

import locationIcon from '../../assets/img/location.png'
import foodIcon from '../../assets/img/foodicon.png'
import payIcon from '../../assets/img/payicon.png'
import heroimage from '../../assets/img/herogif.gif'

import logo from '../../assets/img/doorbox.png'; 

import paystacklogo from '../../assets/img/paystack.png'; 
import pwalogo from '../../assets/img/pwa-logo2.png'; 
import ouchlogo from '../../assets/img/ouch.png'; 
import food from '../../assets/img/food.png'; 
import errand from '../../assets/img/errand.png'; 


import AOS from "aos";
import "aos/dist/aos.css";


const Home = ({scrolltoSignal, countSignal} : any) => {

    const [value, setValue] = useState('');
    const [faqcontent, setFaqcontent] = useState('')
    const [isMobile, setIsMobile] = useState(true)

    useEffect(() => {

      handleResize()
    var timer1 =  setTimeout(() => {
        AOS.init( {
          disable: false
         });
        var getcontent: any = document.getElementById('body_1')?.innerText;
        setFaqcontent(getcontent)

        
        window.addEventListener("resize", handleResize)
        // document.addEventListener("DOMContentLoaded", (event) => {
        //   // Your code to run since DOM is loaded and ready
        //   setTimeout(() => {
           
        //   }, 2000);
         
        // });
        // window.addEventListener("load", handleResize)

      }, 10);


      var sethero:any =  document.getElementById('heroimage');
      sethero.style.display = 'none';
     var time2 = setTimeout(() => {

        setRandomHero(sethero)

      
        clearInterval(time2)
        clearInterval(timer1)
        AOS.refresh()
       }, 1000);


    }, [])


    function setRandomHero(sethero: any) {
      
      // var array = [heroimage, heroimage2];

      // const randomElement = array[Math.floor(Math.random() * array.length)];
       console.log('random selectede')
      // sethero.src = randomElement;
      sethero.src = heroimage;
      sethero.style.display = 'block';
      // console.log(randomElement);

    }

    useEffect(() => {

    const element: any = document.getElementById(scrolltoSignal.value);

    element?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
          
    }, [scrolltoSignal.value])
    
     
   
     function switchelement(mobile: boolean) {

         var parent: any = document.getElementById('heroSection');
      
         var secondchild: any = null;
         var firstchild: any = null;
        if (parent?.hasChildNodes()) {
          firstchild = parent.children[0];
           secondchild = parent.children[1];
          const firstchildclone = firstchild.cloneNode(true);
          const secondchildclone = secondchild.cloneNode(true);

          console.log(firstchild.id)

           if(mobile === true) {

            console.log('mobile is true')
            if(firstchild.id === 'sectionone') {
              firstchild = document.getElementById(firstchild.id);
              parent.removeChild(firstchild);
              parent.insertBefore(firstchildclone, parent.children[1]);
             }
             else {

             }

           }
           else {

            console.log('mobile is false')

            if(firstchild.id === 'sectionone') {
              console.log('first child id:'+firstchild.id)
           
            }
            else {

              console.log('first child id:'+firstchild.id)
              firstchild = document.getElementById(firstchild.id);
              parent.removeChild(firstchild);
              parent.insertBefore(firstchild, parent.children[1]);

            }
        

           }
          

    
        }


     
     }


  

    function GetAccordionClicked(e: any) {

    var firstparent = e.target.closest('.accordion-item');


    var id = firstparent.id.split('_')[1];
 
     var getcontent: any = document.getElementById(`body_${id}`)?.innerText;
     setFaqcontent(getcontent)


     setTimeout(() => {
      if(isMobile === true) {

      }
      else {
    
        firstparent.children[1].classList.remove("show")
  
      }


     }, 500);
     
     console.log(isMobile)
   

    }


    //choose the screen size 
    const handleResize = () => {
        
       console.log(window.innerWidth)
     
      //  AOS.refresh()
       console.log("content loaded!");
      if (window.innerWidth < 700) {
          setIsMobile(true)
          switchelement(true)
          console.log('yes')
      } else {
          setIsMobile(false)
          switchelement(false)
       
        const getaccordion: any = document.querySelectorAll('.accordion .accordion-item')
        for(let eachaccordion of getaccordion){
          eachaccordion?.children[1]?.classList?.remove('show')

          
        }
          console.log('no')
      }
    }


  return (
   




   <div>



<div className='container'>

<div className='heroSection row' id='heroSection'>

<div className='sectionone col-md-6 d-flex justify-content-center flex-column ' id='sectionone'>

<img

loading='lazy'

src={doorboxblob2} width='150px' className='pulsateupdown'

data-aos="zoom-in"
data-aos-offset="10"
data-aos-duration="1500"

          alt= "Doorbox.ng blob"/>
<div id='herotextdiv'>

<h1  className='display-4' data-aos="fade-up"
     data-aos-offset="50"
     data-aos-duration="500"
  
     
     > 

Everything You Need
</h1>


<h1 className='' data-aos="fade-up"
     data-aos-offset="50"
     data-aos-duration="1000"
   > 

<label className='doorbox_text_color_primary display-4' style={{marginRight: '8px'}} > DELIVERED   </label>
   to you in minutes...
</h1>

<div data-aos="fade-up"
     data-aos-offset="50"
     data-aos-duration="2000"
   >
<label className='subtext'> We have curated a list of food vendors around you, you can start ordering your favorite meals in 3 simple steps.</label>
{/* <label> </label> */}
</div>

<Button data-aos="fade-up"
     data-aos-offset="100"
     data-aos-duration="3000"
    variant="primary" size="lg" className='roundedbuttonbig mt-3'  href='https://app.doorbox.ng/login' target='_blank'>
Place Order
</Button>{' '}

</div>

</div>



<div className='col-md-6 d-flex justify-content-center  sectiontwo' id='sectiontwo'>

<img

loading='lazy'
  
src={doorboxblob} width='700px' id='mainblob' className='pulsateupdownslow'

data-aos="zoom-in"
data-aos-offset="10"
data-aos-duration="1500"

          alt= "Doorbox.ng blob"/>

{/* src={heroimage} */}
<img src={''} className='pulsateupdownslow heroimage' id='heroimage' loading='lazy'
          alt= "Doorbox.ng blob"/>
 
</div>

</div>


<div className='howtosection d-flex justify-content-center '

     data-aos="fade-up"
     data-aos-offset="10"
     data-aos-duration="2000"

>

   <div className='howtobox'>

     <div className='row'>

<div className='col-md-4 d-flex  flex-column  justify-content-center'

data-aos="fade-up"
data-aos-offset="10"
data-aos-duration="1500"

>

<div className='howtoiconbox rotateright45deg align-self-center '>
<img loading='lazy' src={locationIcon} width='100px' height='100px' alt='doorbox.ng'/>
</div>

<label className='align-self-center '>Enter your location</label>
</div>

<div className='col-md-4 d-flex  flex-column  justify-content-center'

data-aos="fade-up"
data-aos-offset="100"
data-aos-duration="2000"

>

<div className='howtoiconbox rotateright45deg align-self-center '>
<img loading='lazy' src={foodIcon} width='80px' height='80px' alt='doorbox.ng'/>
</div>
<label className='align-self-center '>Select your menu</label>

</div>

<div className='col-md-4 d-flex  flex-column  justify-content-center'

data-aos="fade-up"
data-aos-offset="100"
data-aos-duration="3000"

>

<div className='howtoiconbox rotateright45deg align-self-center'>
<img loading='lazy' src={payIcon} width='80px' height='80px' alt='doorbox.ng'/>
</div>
<label className='align-self-center '>Pay and wait...</label>

</div>

     </div>
   </div>

   </div>





   <div className='fooddetailsection row doorbox_gradient_bg' id='servicesection'
   
   data-aos="fade-up"
   data-aos-offset="100"
   data-aos-duration="1000"

   >

    <div className='col-md-6 imgboxsection d-flex  justify-content-center '>


      <div className='imgbox rotateright10deg'>

      <img 
      data-aos="fade-right"
      data-aos-offset="100"
      data-aos-duration="1500"
      loading='lazy'
      src={food} width='250px' height='250px' alt='doorbox.ng'/>

      </div>

    </div>


    <div className='col-md-6 textboxsection'>
      
      <h2 className='textondarkdeep'>
      INSTANT FOOD
      DELIVERY
      </h2>

      <label className='textondarksubtle'>
      Let’s make it easier. You can count on our brand for swift delivery and customer’s satisfaction.
      </label>

      <Button
      
      data-aos="fade-up"
      data-aos-offset="100"
      data-aos-duration="3000"
      
      variant="primary" size="lg" className='mt-3 roundedbuttonbig'  href='https://app.doorbox.ng/login' target='_blank'>
      Place Order
      </Button>

    </div>



    <div>

    </div>


   </div>



   <div className='slidersection'
   
   data-aos="zoom-in-up"
   data-aos-offset="200"
   data-aos-duration="1000"

   >

    <Swipercomponent />
   </div>




   <div className='errandetailsection row doorbox_gradient_bg'
   
     
   data-aos="fade-up"
   data-aos-offset="100"
   data-aos-duration="1000"
   >

    <div className='col-md-6 imgboxsection d-flex  justify-content-center '>


      <div className='imgbox rotateright10deg'>

      <img
      
      loading='lazy'
        
    data-aos="fade-right"
    data-aos-offset="100"
    data-aos-duration="2000"

      src={errand} width='250px' height='250px' alt='doorbox.ng'/>


      </div>

    </div>


    <div className='col-md-6 textboxsection'
    
  
    
    >
      
      <h2 className='textondarkdeep'>
      FAST ERRAND
      SERVICES
      </h2>

      <label className='textondarksubtle'>
      Running errands can be very worrisome and tedious, but having a brand you can trust can help ease the burden. At doorbox, we render topnotch service and we have been able to build trust when it comes to providing quality services
      </label>

      <Button 
      
        
    data-aos="fade-up"
    data-aos-offset="100"
    data-aos-duration="2000"
    variant="primary" size="lg" className='mt-3 roundedbuttonbig'  href='https://app.doorbox.ng/login' target='_blank'>
      Place Order
      </Button>

    </div>



    <div>

    </div>


   </div>

   <div className='faqsection' id='faqsection'
   
     
   data-aos="fade-up"
   data-aos-offset="100"
   data-aos-duration="500"
   >


   <div className='mb-4'>
    <h1>
      FAQs
    </h1>
   </div>

  <div className='accordionbox row'>

   <div className='col-md-6 accordionbox1'>

<Accordion  defaultActiveKey="1">
   <Accordion.Item eventKey="1" id='accordion_1' onClick={GetAccordionClicked}>
     <Accordion.Header>How do I order?</Accordion.Header>
  
 
     <Accordion.Body id='body_1'  >
     To place an order, you first need to create an account with DoorBox, then login to find available vendors near you to place your order
    </Accordion.Body>
  
   </Accordion.Item>

   <Accordion.Item eventKey="2" id='accordion_2'  onClick={GetAccordionClicked}>
     <Accordion.Header>When can I order?</Accordion.Header>

    
        <Accordion.Body id='body_2'>
        We are open daily from 6a.m to 10p.m
        </Accordion.Body>
  
   
   </Accordion.Item>

   <Accordion.Item eventKey="3" id='accordion_3'  onClick={GetAccordionClicked}>
     <Accordion.Header>How do I pay for my order?</Accordion.Header>

    
        <Accordion.Body id='body_3'>
        On the DoorBox app you can complete payment for your order using the popular paystack gateway which is integrated into DoorBox
        </Accordion.Body>
  
   
   </Accordion.Item>


   <Accordion.Item eventKey="4" id='accordion_4'  onClick={GetAccordionClicked}>
     <Accordion.Header>Can I place a pickup order?</Accordion.Header>

    
        <Accordion.Body id='body_4'>
       Yes, on the app select pickup then select the time you want to pickup the order
        </Accordion.Body>
  
   
   </Accordion.Item>

   <Accordion.Item eventKey="5" id='accordion_5'  onClick={GetAccordionClicked}>
     <Accordion.Header>What happens if I am debited without being credited on the app?</Accordion.Header>

    
        <Accordion.Body id='body_5'>
        Our customer success team would credit your profile with the exact amount immediately
        </Accordion.Body>
  
   
   </Accordion.Item>

 </Accordion>

</div>



{ isMobile === false ? 


(<div className='col-md-6 accordionbox2'>

{faqcontent}
 
</div>)


: ''}



   </div>

   </div>




   <div className='aboutsection' id='aboutsection'
   
     
   data-aos="fade-up"
   data-aos-offset="100"
   data-aos-duration="500"
   >

<div className='aboutbox row'>

  <div className='col-md-3'> 

    <div className='aboutimgbox rotateright10deg'>
      

   <img 
   
   
   loading='lazy'
   data-aos="fade-right"
   data-aos-offset="100"
   data-aos-duration="1000"
   
   src={logo} width='150px' height={'150px'} className='aboutimage'
          alt= "Doorbox.ng blob"/>
           
    </div>
  </div>

  <div className='col-md-9'>
    
    <h2>About <label className='doorbox_text_color_primary'>DOORBOX</label></h2>

    <label>
   
At Doorbox we understand the importance of time and satisfaction of one’s cravings and we’ve got you covered.
    </label>

    <label>
   
    We help you ease your stress by bringing to your doorstep delicious delicacies so you can indulge your cravings without having to leave your space.

       </label>
  </div>

</div>


   </div>



  </div>



   {/* footer cpontainer  */}

<footer className='footersection doorbox_gradient_bg'>


<div className='mainlistbox'>
<ul className='mainlist'>

<li className='mainli'

  
data-aos="fade-up"
data-aos-offset="0"
data-aos-duration="1000"
>
  <h4>Pages</h4>
   <ul>
    <li className='subli'> 
      Home
    </li>

    <li className='subli'> 
      Contact Us
    </li>

    <li className='subli'> 
      About Us
    </li>
   </ul>
</li>

<li className='mainli'

  
data-aos="fade-up"
data-aos-offset="0"
data-aos-duration="1500"
>
  <h4>Services</h4>

  <ul>
    <li className='subli'> 
      Food Delivery
    </li>

    <li className='subli'> 
      Errands
    </li>

    <li className='subli'> 
        Others...
    </li>
   </ul>

</li>

<li className='mainli' id='contactsection'

  
data-aos="fade-up"
data-aos-offset="0"
data-aos-duration="2000"
>
  <h4>Contact Us</h4>

  <ul>
    <li className='subli'> 
    104 Road, Wuse, Abuja
    </li>

    <li className='subli'> 
      -
    </li>

    <li className='subli'> 
      -
    </li>
   </ul>

</li>


<li className='mainli socials'

  
data-aos="fade-up"
data-aos-offset="0"
data-aos-duration="2700"
>

<h4>Socials</h4>
<ul>
    <li className='subli '> 


    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 50 50">
<path d="M 16 3 C 8.8324839 3 3 8.8324839 3 16 L 3 34 C 3 41.167516 8.8324839 47 16 47 L 34 47 C 41.167516 47 47 41.167516 47 34 L 47 16 C 47 8.8324839 41.167516 3 34 3 L 16 3 z M 16 5 L 34 5 C 40.086484 5 45 9.9135161 45 16 L 45 34 C 45 40.086484 40.086484 45 34 45 L 16 45 C 9.9135161 45 5 40.086484 5 34 L 5 16 C 5 9.9135161 9.9135161 5 16 5 z M 37 11 A 2 2 0 0 0 35 13 A 2 2 0 0 0 37 15 A 2 2 0 0 0 39 13 A 2 2 0 0 0 37 11 z M 25 14 C 18.936712 14 14 18.936712 14 25 C 14 31.063288 18.936712 36 25 36 C 31.063288 36 36 31.063288 36 25 C 36 18.936712 31.063288 14 25 14 z M 25 16 C 29.982407 16 34 20.017593 34 25 C 34 29.982407 29.982407 34 25 34 C 20.017593 34 16 29.982407 16 25 C 16 20.017593 20.017593 16 25 16 z"></path>
</svg>

<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 50 50">
<path d="M 11 4 C 7.1456661 4 4 7.1456661 4 11 L 4 39 C 4 42.854334 7.1456661 46 11 46 L 39 46 C 42.854334 46 46 42.854334 46 39 L 46 11 C 46 7.1456661 42.854334 4 39 4 L 11 4 z M 11 6 L 39 6 C 41.773666 6 44 8.2263339 44 11 L 44 39 C 44 41.773666 41.773666 44 39 44 L 11 44 C 8.2263339 44 6 41.773666 6 39 L 6 11 C 6 8.2263339 8.2263339 6 11 6 z M 13.085938 13 L 22.308594 26.103516 L 13 37 L 15.5 37 L 23.4375 27.707031 L 29.976562 37 L 37.914062 37 L 27.789062 22.613281 L 36 13 L 33.5 13 L 26.660156 21.009766 L 21.023438 13 L 13.085938 13 z M 16.914062 15 L 19.978516 15 L 34.085938 35 L 31.021484 35 L 16.914062 15 z"></path>
</svg>



    </li>



<li className='subli '>
<a rel="noreferrer"  href="https://www.linkedin.com/in/doorbox-ng-52019b282/" target="_blank"  title="Doorbox.ng food delivery Nigeria"
>
<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 50 50">
<path d="M 9 4 C 6.2504839 4 4 6.2504839 4 9 L 4 41 C 4 43.749516 6.2504839 46 9 46 L 41 46 C 43.749516 46 46 43.749516 46 41 L 46 9 C 46 6.2504839 43.749516 4 41 4 L 9 4 z M 9 6 L 41 6 C 42.668484 6 44 7.3315161 44 9 L 44 41 C 44 42.668484 42.668484 44 41 44 L 9 44 C 7.3315161 44 6 42.668484 6 41 L 6 9 C 6 7.3315161 7.3315161 6 9 6 z M 14 11.011719 C 12.904779 11.011719 11.919219 11.339079 11.189453 11.953125 C 10.459687 12.567171 10.011719 13.484511 10.011719 14.466797 C 10.011719 16.333977 11.631285 17.789609 13.691406 17.933594 A 0.98809878 0.98809878 0 0 0 13.695312 17.935547 A 0.98809878 0.98809878 0 0 0 14 17.988281 C 16.27301 17.988281 17.988281 16.396083 17.988281 14.466797 A 0.98809878 0.98809878 0 0 0 17.986328 14.414062 C 17.884577 12.513831 16.190443 11.011719 14 11.011719 z M 14 12.988281 C 15.392231 12.988281 15.94197 13.610038 16.001953 14.492188 C 15.989803 15.348434 15.460091 16.011719 14 16.011719 C 12.614594 16.011719 11.988281 15.302225 11.988281 14.466797 C 11.988281 14.049083 12.140703 13.734298 12.460938 13.464844 C 12.78117 13.19539 13.295221 12.988281 14 12.988281 z M 11 19 A 1.0001 1.0001 0 0 0 10 20 L 10 39 A 1.0001 1.0001 0 0 0 11 40 L 17 40 A 1.0001 1.0001 0 0 0 18 39 L 18 33.134766 L 18 20 A 1.0001 1.0001 0 0 0 17 19 L 11 19 z M 20 19 A 1.0001 1.0001 0 0 0 19 20 L 19 39 A 1.0001 1.0001 0 0 0 20 40 L 26 40 A 1.0001 1.0001 0 0 0 27 39 L 27 29 C 27 28.170333 27.226394 27.345035 27.625 26.804688 C 28.023606 26.264339 28.526466 25.940057 29.482422 25.957031 C 30.468166 25.973981 30.989999 26.311669 31.384766 26.841797 C 31.779532 27.371924 32 28.166667 32 29 L 32 39 A 1.0001 1.0001 0 0 0 33 40 L 39 40 A 1.0001 1.0001 0 0 0 40 39 L 40 28.261719 C 40 25.300181 39.122788 22.95433 37.619141 21.367188 C 36.115493 19.780044 34.024172 19 31.8125 19 C 29.710483 19 28.110853 19.704889 27 20.423828 L 27 20 A 1.0001 1.0001 0 0 0 26 19 L 20 19 z M 12 21 L 16 21 L 16 33.134766 L 16 38 L 12 38 L 12 21 z M 21 21 L 25 21 L 25 22.560547 A 1.0001 1.0001 0 0 0 26.798828 23.162109 C 26.798828 23.162109 28.369194 21 31.8125 21 C 33.565828 21 35.069366 21.582581 36.167969 22.742188 C 37.266572 23.901794 38 25.688257 38 28.261719 L 38 38 L 34 38 L 34 29 C 34 27.833333 33.720468 26.627107 32.990234 25.646484 C 32.260001 24.665862 31.031834 23.983076 29.517578 23.957031 C 27.995534 23.930001 26.747519 24.626988 26.015625 25.619141 C 25.283731 26.611293 25 27.829667 25 29 L 25 38 L 21 38 L 21 21 z"></path>
</svg>
</a>

<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 50 50">
<path d="M 25 2 C 12.309534 2 2 12.309534 2 25 C 2 29.079097 3.1186875 32.88588 4.984375 36.208984 L 2.0371094 46.730469 A 1.0001 1.0001 0 0 0 3.2402344 47.970703 L 14.210938 45.251953 C 17.434629 46.972929 21.092591 48 25 48 C 37.690466 48 48 37.690466 48 25 C 48 12.309534 37.690466 2 25 2 z M 25 4 C 36.609534 4 46 13.390466 46 25 C 46 36.609534 36.609534 46 25 46 C 21.278025 46 17.792121 45.029635 14.761719 43.333984 A 1.0001 1.0001 0 0 0 14.033203 43.236328 L 4.4257812 45.617188 L 7.0019531 36.425781 A 1.0001 1.0001 0 0 0 6.9023438 35.646484 C 5.0606869 32.523592 4 28.890107 4 25 C 4 13.390466 13.390466 4 25 4 z M 16.642578 13 C 16.001539 13 15.086045 13.23849 14.333984 14.048828 C 13.882268 14.535548 12 16.369511 12 19.59375 C 12 22.955271 14.331391 25.855848 14.613281 26.228516 L 14.615234 26.228516 L 14.615234 26.230469 C 14.588494 26.195329 14.973031 26.752191 15.486328 27.419922 C 15.999626 28.087653 16.717405 28.96464 17.619141 29.914062 C 19.422612 31.812909 21.958282 34.007419 25.105469 35.349609 C 26.554789 35.966779 27.698179 36.339417 28.564453 36.611328 C 30.169845 37.115426 31.632073 37.038799 32.730469 36.876953 C 33.55263 36.755876 34.456878 36.361114 35.351562 35.794922 C 36.246248 35.22873 37.12309 34.524722 37.509766 33.455078 C 37.786772 32.688244 37.927591 31.979598 37.978516 31.396484 C 38.003976 31.104927 38.007211 30.847602 37.988281 30.609375 C 37.969311 30.371148 37.989581 30.188664 37.767578 29.824219 C 37.302009 29.059804 36.774753 29.039853 36.224609 28.767578 C 35.918939 28.616297 35.048661 28.191329 34.175781 27.775391 C 33.303883 27.35992 32.54892 26.991953 32.083984 26.826172 C 31.790239 26.720488 31.431556 26.568352 30.914062 26.626953 C 30.396569 26.685553 29.88546 27.058933 29.587891 27.5 C 29.305837 27.918069 28.170387 29.258349 27.824219 29.652344 C 27.819619 29.649544 27.849659 29.663383 27.712891 29.595703 C 27.284761 29.383815 26.761157 29.203652 25.986328 28.794922 C 25.2115 28.386192 24.242255 27.782635 23.181641 26.847656 L 23.181641 26.845703 C 21.603029 25.455949 20.497272 23.711106 20.148438 23.125 C 20.171937 23.09704 20.145643 23.130901 20.195312 23.082031 L 20.197266 23.080078 C 20.553781 22.728924 20.869739 22.309521 21.136719 22.001953 C 21.515257 21.565866 21.68231 21.181437 21.863281 20.822266 C 22.223954 20.10644 22.02313 19.318742 21.814453 18.904297 L 21.814453 18.902344 C 21.828863 18.931014 21.701572 18.650157 21.564453 18.326172 C 21.426943 18.001263 21.251663 17.580039 21.064453 17.130859 C 20.690033 16.232501 20.272027 15.224912 20.023438 14.634766 L 20.023438 14.632812 C 19.730591 13.937684 19.334395 13.436908 18.816406 13.195312 C 18.298417 12.953717 17.840778 13.022402 17.822266 13.021484 L 17.820312 13.021484 C 17.450668 13.004432 17.045038 13 16.642578 13 z M 16.642578 15 C 17.028118 15 17.408214 15.004701 17.726562 15.019531 C 18.054056 15.035851 18.033687 15.037192 17.970703 15.007812 C 17.906713 14.977972 17.993533 14.968282 18.179688 15.410156 C 18.423098 15.98801 18.84317 16.999249 19.21875 17.900391 C 19.40654 18.350961 19.582292 18.773816 19.722656 19.105469 C 19.863021 19.437122 19.939077 19.622295 20.027344 19.798828 L 20.027344 19.800781 L 20.029297 19.802734 C 20.115837 19.973483 20.108185 19.864164 20.078125 19.923828 C 19.867096 20.342656 19.838461 20.445493 19.625 20.691406 C 19.29998 21.065838 18.968453 21.483404 18.792969 21.65625 C 18.639439 21.80707 18.36242 22.042032 18.189453 22.501953 C 18.016221 22.962578 18.097073 23.59457 18.375 24.066406 C 18.745032 24.6946 19.964406 26.679307 21.859375 28.347656 C 23.05276 29.399678 24.164563 30.095933 25.052734 30.564453 C 25.940906 31.032973 26.664301 31.306607 26.826172 31.386719 C 27.210549 31.576953 27.630655 31.72467 28.119141 31.666016 C 28.607627 31.607366 29.02878 31.310979 29.296875 31.007812 L 29.298828 31.005859 C 29.655629 30.601347 30.715848 29.390728 31.224609 28.644531 C 31.246169 28.652131 31.239109 28.646231 31.408203 28.707031 L 31.408203 28.708984 L 31.410156 28.708984 C 31.487356 28.736474 32.454286 29.169267 33.316406 29.580078 C 34.178526 29.990889 35.053561 30.417875 35.337891 30.558594 C 35.748225 30.761674 35.942113 30.893881 35.992188 30.894531 C 35.995572 30.982516 35.998992 31.07786 35.986328 31.222656 C 35.951258 31.624292 35.8439 32.180225 35.628906 32.775391 C 35.523582 33.066746 34.975018 33.667661 34.283203 34.105469 C 33.591388 34.543277 32.749338 34.852514 32.4375 34.898438 C 31.499896 35.036591 30.386672 35.087027 29.164062 34.703125 C 28.316336 34.437036 27.259305 34.092596 25.890625 33.509766 C 23.114812 32.325956 20.755591 30.311513 19.070312 28.537109 C 18.227674 27.649908 17.552562 26.824019 17.072266 26.199219 C 16.592866 25.575584 16.383528 25.251054 16.208984 25.021484 L 16.207031 25.019531 C 15.897202 24.609805 14 21.970851 14 19.59375 C 14 17.077989 15.168497 16.091436 15.800781 15.410156 C 16.132721 15.052495 16.495617 15 16.642578 15 z"></path>
</svg>
</li>

<li className='subli '>
  -
</li>


  
  </ul>



</li>


<li className='mainli' 
data-aos="fade-up"
data-aos-offset="0"
data-aos-duration="3000"
>

<ul>
    <li className='subli logos'> 
      <img src={paystacklogo}  height={'50px'} loading='lazy'></img>
    </li>

    <li className='subli logos'> 

    <img loading='lazy' src={pwalogo}  height={'50px'} className='me-2'></img>

    <img loading='lazy' src={ouchlogo}  height={'50px'}></img>
    </li>

    <li className='subli'> 
    -
    </li>
  </ul>



</li>
</ul>
</div>


<div className='d-flex justify-content-center mt-5'>
  <small className='textondarksubtle'>All rights reserved @DoorBox 2024 ❤️</small>
</div>

</footer>

   </div>

  
 

  )
}

export default Home